<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <strong>مستندات</strong>
        </CCardHeader>
        <CCardBody>
            <p>نسخه دوم مستندات API سامانه گام دوم در ادامه آورده شده است. هر گونه بروزرسانی این مستندات از طریق همین صفحه به اطلاع کاربران خواهد رسید.</p>
            <hr>
            <h5>ارسال پیام (متنی)</h5>
            <br/>
            <p>به منظور ارسال پیام از طریق سامانه میتوان از API زیر بهره برد. این API در هر اتصال این امکان را دارد که تا ۱۰۰ شماره گیرنده منحصر به فرد را پشتیبانی کند و از سوی دیگر هیچ محدودیتی تا به این لحظه برای ارسال درنظر گرفته نشده است. لازم است این اطلاعات با فرمت JSON و  به صورت POST برای  سامانه ارسال شود. لازم است توکن کاربر در هدر Authorization برای سیستم ارسال شود. شرح مستندات مربوط به ارسال پیام در قسمت زیر آورده شده است:</p>
            <pre class="curl">
            {
              "message":"سلام",
              "to_numbers":["98XXXXXXXXXX", "0935XXXXXXX"],
              "unique_ids":[ "1", "2"],
              "from_number":"XXXXXXX"
            }
            </pre>
            <CDataTable
                hover
                striped
                :items="[
                {name: 'message', type: 'STRING', state: 'اجباری', desc: 'متن پیام در این قسمت آورده می‌شود.'},
                {name: 'to_numbers', type: 'STRING', state: 'اجباری', desc: 'آرایه ای از شماره های مقصد در این قسمت آورده می شود. طول این ارایه از ۱ تا ۱۰۰ شماره است.'},
                {name: 'unique_ids', type: 'STRING', state: 'اجباری', desc: 'این آرایه به منظور ارسال شناسه یکتا برای هر پیام استفاده می‌شود . این شناسه میتواند مانع از ارسال پیام‌های تکراری به سیستم شود. لازم است این آرایه یا به صورت خالی باشد و یا به تعداد شماره های مقصد شناسه های یکتا به طول حداقل ۱ و حداکثر ۶۰ کارکتر را دارا باشد. مدت زمان اعتبار هر شناسه یکتا 60 دقیقه می‌باشد. '},
                {name: 'from_number', type: 'STRING', state: 'اجباری', desc: 'شماره مبدأ در این فیلد قرار داده می‌شود.'},]"
                :fields="[
                { key: 'name', label: 'نام فیلد' },
                { key: 'type', label: 'نوع' },
                { key: 'state', label: 'وضعیت' },
                { key: 'desc', label: 'شرح فیلد' },]"
            />
            <hr>
            <h5>نمونه ارسال</h5>
            <br/>
            <pre class="curl">
            curl -X POST http://79.127.125.80:8083/api-v1/send_sms -H "Authorization: token " -H "Content-Type: application/json"
            -d "{\"message\":\"Hi\",
            \"to_numbers\":[\"98XXXXXXXXXX\",\"0935XXXXXXX\",\"98XXXXXXXXXX\",\"98XXXXXXXXXX\",\"98XXXXXXXXXX\"],
            \"unique_ids\":[\"1\",\"2\",\"3\",\"4\",\"5\"],
            \"from_number\":\"XXXXXXX\"}"
            </pre>
            <p>در صورت بروزخطا پیام بازگشتی با هدر 400 قابل دریافت است و در صورت صحت اطلاعات و مقادیر ارسال شده، پاسخ زیر با هدر 200 به کاربر بازگردانده می‌شود: </p>
            <pre class="curl">
            {
              "sms_response":[
                  {
                    "to_number":"98XXXXXXX",
                    "sms_id":"XXXXXXX-XXX-XXX-XXX-XXXXXXXXXXXXXX",
                    "is_send":true
                  }
              ],
              "from_number":"XXXXXXX",
              "sms_group_id":"XXXXXXX-XXX-XXX-XXX-XXXXXXXXXXXXXX",
              "fee_sum":XX
            }
            </pre>
            <p>آرایه sms_response یک آرایه از پیام‌های ارسالی را شامل می‌شود که در آن اطلاعات پیام‌های ارسالی آورده شده است. در این لیست فیلد  is_send به دریافت موفق پیام اشاره میکند که در صورت خطا در دریافت پیام، مقدار این فیلد برابر با False می‌باشد.</p>
            <hr>
            <h5>خطا</h5>
            <br/>
            <p>در صورت بروز خطا، پاسخ دریافتی با هدر 400 می‌باشد و موارد به صورت زیر می‌باشد:</p>
            <pre class="curl">
            {
              "state":"Error",
              "error_str":"XXX",
              "error_code":XX
            }
            </pre>
            <CDataTable
                hover
                striped
                :items="[
                {error: 'داده ارسال شده نامعتبر است.', code: '20'},
                {error: 'داده ارسالی برای توکن معتبر نمی باشد.', code: '21'},
                {error: 'طول شماره های مقصد از ۱ تا حداکثر ۱۰۰ شماره میتواند باشد.', code: '22'},
                {error: 'تعداد پیام های ارسالی روزانه برای این توکن به حداکثر رسیده است.', code: '23'},
                {error: 'شارژ حساب کاربری کافی نمی باشد.', code: '24'},
                {error: 'دسترسی به وب سرویس برای شما امکانپذیر نمی باشد.', code: '25'},
                {error: 'IP مبدا معتبر نیست.', code: '26'},
                {error: 'شماره مبدا معتبر نمی باشد.', code: '27'},
                {error: 'ارسال از این مسیر معتبر نمی باشد.', code: '28'},
                {error: 'متن پیام ارسالی نامعتبر است.', code: '29'},
                {error: 'طول شناسه های ارسال شده برای پیام یکتا باید برابر با تعداد شماره های گیرنده پیام باشد.', code: '30'},
                {error: 'طول شناسه های ارسال شده برای پیام یکتا باید بیشتر از ۱ و کمتر از ۶۰ کارکتر باشد.', code: '31'},]"
                :fields="[
                { key: 'error', label: 'خطا' },
                { key: 'code', label: 'کد' },]"
            />
            <hr>
            <h5>دریافت وضعیت پیام‌ها</h5>
            <br/>
            <p>پس از ارسال هر پیام حداکثر تا 24 ساعت (در 2000 و 5000, حداکثر تا 48 ساعت) وضعیت پیام‌ها مشخص می‌شود. به منظور دریافت وضعیت پیام لازم است یک درخواست با فرمت JSON و  به صورت POST برای  سامانه ارسال شود. آرایه شناسه های ارسال شده میتواند تا 100شناسه یکتا را در خود جای دهد.  همانند درخواست ارسال پیام باید توکن کاربر در هدر Authorization برای سیستم ارسال شود . شرح مستندات مربوط به دریافت وضعیت پیام در قسمت زیر آورده شده است:</p>
            <pre class="curl">
            curl -X POST http://79.127.125.80:8083/api-v1/get_delivery  -H "Authorization: XXXXX-XXXX-XXXX-XXXX-XXXXXXXX "
            -H "Content-Type: application/json" 
            -d "{\"uuid_array\":[\"XXXXX-XXXX-XXXX-XXXX-XXXXXXXX\",\"XXXXX-XXXX-XXXX-XXXX-XXXXXXXX\"]}"
            </pre>
            <p>در صورت صحت اطلاعات ارسالی پاسخ زیر را دریافت خواهید کرد:</p>
            <pre class="curl">
            {
              "delivery_response":[
                  {
                    "message_uuid":"XXXXX-XXXX-XXXX-XXXX-UNVALID",
                    "to_number":"",
                    "state":-5
                  },
                  {
                    "message_uuid":"XXXXX-XXXX-XXXX-XXXX-XXXXXXXX",
                    "to_number":"98XXXXXXXXXX",
                    "state":0
                  },
              ],
              "valid_count":1,
              "unvalid_count":1,
              "not_found_count":0
            }
            </pre>
            <p>همانطور که در پاسخ بازگشتی آورده شده است، در آرایه delivery_response، وضعیت هر شناسه به تفکیک آورده شده است. در انتها تعداد  valid_count ،unvalid_count و not_found_count آورده شده است. با استفاده از فیلد state هر یک از اعضای آرايه دریافتی میتوان وضعیت پیام ارسال شده را مشخص کرد. جدول زیر وضعیت‌ پیام‌های ارسالی را در خود جای داده است:</p>
            <CDataTable
                hover
                striped
                :items="[
                {state: '-5', title: 'شناسه نامعتبر', desc: 'شناسه ارسال شده برای دریافت وضعیت پیام نامعتبر است.'},
                {state: '-4', title: 'شماره نامتعبر', desc: 'شماره ارسال شده برای ارسال پیام نامعتبر است.'},
                {state: '-3', title: 'خطا در ارسال', desc: 'اگر یک پیام پس از چندین بار تلاش در یک پروسه زمانی چند ساعته در نهایت به سمت مخابرات ارسال نشد، وضعیت پیام به 3- تبدیل می‌شود.'},
                {state: '-2', title: 'تأیید نشده', desc: 'در صورتی که یک پیام تأیید نشود، وضعیت پیام به 2- تبدیل خواهد شد. در این صورت هزینه پیام بازگردانده خواهد شد. '},
                {state: '-1', title: 'بلک لیست', desc: 'در صورتی که شماره مقصد ورودی پیام‌های خود را مسدود کرده باشد، وضعیت پیام به 1- تبدیل می‌شود. در این صورت هزینه بازگشتی پیام با توجه به وضعیت خط به کاربر بازگردانده خواهد شد. '},
                {state: '0', title: 'در حال ارسال', desc: 'پیام در حال ارسال از سمت سامانه به سمت مخابرات و یا از سمت مخابرات به سمت کاربر است. این وضعیت پس از یک روند زمانی تغییر می‌کند و به وضعیت 1، 2 و یا 3 تبدیل می‌شود . '},
                {state: '1', title: 'دلیور شده', desc: 'پیام‌های رسیده به کاربر با این وضعیت تفکیک می شوند.'},
                {state: '2', title: 'دلیور نشده', desc: 'پیام‌های نرسیده به کاربر با این وضعیت تفکیک می شوند. این صورت هزینه بازگشتی پیام با توجه به وضعیت خط به کاربر بازگردانده خواهد شد. '},
                {state: '3', title: 'ارسال شده به مخابرات', desc: 'پیام به مخابرات تحویل داده شده است اما بنا به مشکلات فنی سامانه های مادر وضعیت پیام پس از 24 یا 48 ساعت بروز نشده است و مشخص نیست که پیام به دست کاربر رسیده است و یا نرسیده است. در این صورت هزینه ای به کاربر بازگردانده نخواهد شد. '},]"
                :fields="[
                { key: 'state', label: 'وضعیت' },
                { key: 'title', label: 'عنوان' },
                { key: 'desc', label: 'توضیحات' },]"
            />
            <hr>
            <h5>بررسی وضعیت شارژ کاربر</h5>
            <br/>
            <p>به منظور اطلاع از شارژ کاربر میتوان از طریق API زیر و با ارسال توکن از وضعیت شارژ پنل کاربر اطلاع یافت. این نمونه درخواست در قسمت زیر آورده شده است:</p>
            <pre class="curl">
            curl -X POST http://79.127.125.80:8083/api-v1/get_credit -H "Authorization: XXXXX-XXXX-XXXX-XXXX-XXXXXXXX "
            </pre>
            <p>در صورت صحت اطلاعات ارسال شده پاسخ زیر به سمت کاربر ارسال می‌شود:</p>
            <pre class="curl">
              {"account_balance": 100}
            </pre>
            <hr>
            <h5>آدرس swagger</h5>
            <br/>
            <p><a href="https://idehgate.ir/swagger/index.html">https://idehgate.ir/swagger/index.html</a></p>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
export default {}
</script>
<style scoped>
.curl{
    direction: ltr !important;
    text-align: left !important;
    font-size: 87.5%;
    color: #e83e8c;
    word-wrap: break-word;
}
</style>